import $ from "jquery";
import "bootstrap";
import "flickity";
// import { CountUp } from 'countup.js';
// import LocomotiveScroll from 'locomotive-scroll';


var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');


window.onload = function(){
    window.dispatchEvent(new Event('resize'));
    if (document.querySelectorAll('.carousel-hero').length) {
      document.querySelector('.flickity-viewport').style.height = document.querySelector('.carousel-cell.is-selected .hero-slider-image img').height+'px';
    }
}

/*window.onload = function() {
  var countUp = new CountUp('target', 2000);
  countUp.start();
}

const options = {
  separator: '.',
};
let demo = new CountUp('count-first', 35000, options);
if (!demo.error) {
  demo.start();
} else {
  console.error(demo.error);
}*/

// const scroll = new LocomotiveScroll({
//     el: document.querySelector('[data-scroll-container]'),
//     smooth: true
// });

Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );
// external js: flickity.pkgd.js

// var options = {
//   accessibility: true,
//   prevNextButtons: true,
//   pageDots: true,
//   setGallerySize: false,
//   autoPlay: true,
//   autoPlay: 6000,
//   arrowShape: {
//     x0: 10,
//     x1: 60,
//     y1: 50,
//     x2: 60,
//     y2: 45,
//     x3: 15
//   }
// };

// var carousel = document.querySelector('[data-carousel]');
// var slides = document.getElementsByClassName('carousel-cell');
// var flkty = new Flickity(carousel, options);


// flkty.on('scroll', function () {
//   flkty.slides.forEach(function (slide, i) {
//     var image = slides[i];
//     var x = (slide.target + flkty.x) * -1/3;
//     image.style.backgroundPosition = x + 'px center';
//   });
// });





var $carousel = null;
$carousel = $('.carousel').flickity({
  percentPosition: false,
  pageDots:false,
  prevNextButtons:true,
  autoPlay: false,
  arrowShape: {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 60,
    y2: 45,
    x3: 15
  }
});

$('.magazine-carousel').flickity({
  // options
  cellAlign: 'left',
  contain: false,
  wrapAround: true,
  pageDots: true,
  autoPlay: true,
  draggable: false
});

var $carousel = null;
$carousel = $('.carousel-text-image').flickity({
  percentPosition: false,
  //imagesLoaded: true,
  pageDots:false,
  prevNextButtons:true,
  wrapAround: false,
  autoPlay: true,
  contain: true,
  arrowShape: {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 60,
    y2: 45,
    x3: 15
  }
});
//if ($carousel.length == 0) {
  var autoplay = $('.carousel-hero').hasClass('singleimage') ? false : 5000;
  var sliding = $('.carousel-hero').find('.carousel-cell').length > 1;
  $carousel = $('.carousel-hero').flickity({
    percentPosition: true,
    pageDots: sliding,
    wrapAround: true,
    prevNextButtons: sliding,
    pauseAutoPlayOnHover:false,
    //setGallerySize:true,
    autoPlay: true,
    adaptiveHeight: true,
    selectedAttraction: 0.023,
    arrowShape: {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 60,
    y2: 45,
    x3: 15
    }
  });


  var autoplay = $('.carousel-hero').hasClass('singleimage') ? false : 5000;
  var sliding = $('.carousel-hero').find('.carousel-cell').length > 1;
  $carousel = $('.carousel-hero').flickity({
    percentPosition: true,
    pageDots: sliding,
    wrapAround: true,
    prevNextButtons: sliding,
    pauseAutoPlayOnHover:false,
    //setGallerySize:true,
    autoPlay: true,
    adaptiveHeight: true,
    selectedAttraction: 0.023,
    arrowShape: {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 60,
    y2: 45,
    x3: 15
    }
  });


//   var $imgs = $carousel.find('.carousel-cell img');

//   var docStyle = document.documentElement.style;
//   var transformProp = typeof docStyle.transform == 'string' ?
//   'transform' : 'WebkitTransform';

//   var flkty = $carousel.data('flickity');

//   $carousel.on('scroll.flickity', function () {
//     flkty.slides.forEach(function (slide, i) {
//       var img = $imgs[i];
//       var x = (slide.target + flkty.x) * -1 / 3;
// 	  if (flkty.slides.length > 1 && i == flkty.slides.length-1 && slide.parent.selectedIndex == 0) {
// 		  x = (((slide.target + flkty.x) * -1) + flkty.slideableWidth)/3;
// 	  }
//       img.style[transformProp] = 'translateX(' + x + 'px)';
//     });
//   });
//   function correctFlickityHeight (ev) {
//     if (document.querySelectorAll('.carousel-hero').length) {
//       $carousel.on(ev, function(){
//         if ($(window).width() >= 1200){
//           document.querySelector('.flickity-viewport').style.height = document.querySelector('.carousel-cell.is-selected .hero-slider-image img').height+'px';
//         }
//         else {
//           document.querySelector('.flickity-viewport').style.height = document.querySelector('.carousel-cell.is-selected .hero-slider-image img').height + document.querySelector('.carousel-cell.is-selected .hero-slider-image .hero-caption').height+'px';
//         }
//       });
//     }
//   }
//   if (document.querySelectorAll('.carousel-hero').length) {
//     correctFlickityHeight('ready.flickity');
//     correctFlickityHeight('change.flickity');
//     correctFlickityHeight('settle.flickity');
//     document.querySelectorAll('.flickity-page-dots').forEach((dots) => {
//       if (dots.children.length == 1) {
//         dots.style.display = "none";
//         dots.parent
//         dots.previousSibling('flickity-button').forEach((btns) => {
//           btns.style.display = "none";
//         })
//       }
//     });
//   }

// if (document.location.search.match(/type=embed/gi)) {
//   window.parent.postMessage("resize", "*");
// }





window.console = window.console || function(t) {};

setTimeout(function() {

  $(function() {
    $(window).trigger('resize');

  });
}, 100);

// external js: flickity.pkgd.js

/*var $carousel = $('.carousel-hero').flickity({
  pageDots:false,
  prevNextButtons:true,
});*/
var $carouselStatus = $('.carousel-status');
var flkty = $carousel.data('flickity');

function updateStatus() {
  if($carouselStatus !== 'undefined'){
  var cellNumber = flkty.selectedIndex + 1;
  $carouselStatus.html( cellNumber + '<span>/</span>' + '<span>' + flkty.slides.length + '</span>' );
  }
}

if ($carousel.length) {
  updateStatus();
  $carousel.on( 'change.flickity', updateStatus );
}






// MENU

$("[data-trigger]").on("click", function(){
    var trigger_id =  $(this).attr('data-trigger');
    $(trigger_id).toggleClass("show");
    $('body').toggleClass("offcanvas-active");
});



$('.burger-menu').on('click', function() {
  $(this).toggleClass("burger-menu--opened");
  $(this).toggleClass("burger-menu--closed");
});

$(document).ready(function() {

  if ($carousel.length) {
    if (flkty.slides.length == 1){
      $('.carousel-status').hide();
    }
    function toggleNavbarMethod() {
        if ($(window).width() > 768) {
            $('.navbar .dropdown').on('mouseover', function(){
                $('.dropdown-toggle', this).trigger('click');
            }).on('mouseout', function(){
                $('.dropdown-toggle', this).trigger('click').blur();
            });
        }
        else {
            $('.navbar .dropdown').off('mouseover').off('mouseout');
        }
    }
    toggleNavbarMethod();
    $(window).resize(toggleNavbarMethod);
  }
});

// $(document).ready(function() {
//   $(window).on("load scroll", function() {
//     var parallaxElement = $(".news-teaser"),
//       parallaxQuantity = parallaxElement.length;
//     window.requestAnimationFrame(function() {
//       for (var i = 0; i < parallaxQuantity; i++) {
//         var currentElement = parallaxElement.eq(i),
//           windowTop = $(window).scrollTop(),
//           elementTop = currentElement.offset().top,
//           elementHeight = currentElement.height(),
//           viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
//           scrolled = windowTop - elementTop + viewPortHeight;
//         currentElement.css({
//           transform: "translate3d(0," + scrolled * -0.20 + "px, 0)"
//         });
//       }
//     });
//   });
// });

$(document).ready(function() {
    setTimeout(function() {
        $("#searchTopic").focus();
    }, 1500);

      $("[data-toggle=popover]").popover({
        html : true,
        trigger: 'hover',
        content: function() {
            var content = $(this).attr("data-popover-content");
            return $(content).children(".popover-body").html();
        }
    });

 });

$(document).ready(function() {
  const params = new URLSearchParams(window.location.search)
  const objectId = params.get('oid')
  if (objectId) {
    $('[data-fill="object-id"]').val(objectId)
  }

  const objectDescription = params.get('odesc')
  if (objectDescription) {

    $('[data-fill="object-description"]').each(function() {
      $(this).val(objectDescription)
      $(this).parents('.d-none').removeClass('d-none')
    })
  }
})

